import * as yup from 'yup';
import { validateRut, formatRut, unformatRut } from './rutValidator';

export const validator = yup;

validator.addMethod(yup.string, 'passwordMatch', function matcher(message) {
  return this.test('passwordMatch', message, (value, { parent: { password } }) => (
    value === password
  ));
});

validator.addMethod(yup.string, 'identificationNumberCheck', function matcher(message) {
  return this.test('identificationNumberCheck', message, (value) => {
    if (!value) {
      return true;
    }
    let cleanRut = `${value}`.replace(/\./g, '');
    if (!cleanRut.includes('-')) {
      cleanRut = formatRut(cleanRut);
    }
    const rutRegex = /^(\d{6,10})-([\dK])$/;
    if (!rutRegex.test(cleanRut)) {
      return false;
    }
    return validateRut(cleanRut);
  });
});

export const identificationNumberParse = (value, originalValue) =>{
  if (value === undefined) {
    return originalValue;
  }

  return formatRut(value);
};

export const identificationNumberUnformat = (value, originalValue) =>{
  if (value === undefined) {
    return originalValue;
  }

  return unformatRut(value);
};

export default validator;
